const sizes = {
  xxxl: '1600.1px',
  xxl: '1200px',
  xl: '1024.1px',
  lg: '991.1px',
  md: '768.1px',
  sm: '576.1px',
  xs: '480.1px'
};

const devices = {
  xxxlMax: `(max-width: ${sizes.xxxl})`,
  xxlMax: `(max-width: ${sizes.xxl})`,
  xlMax: `(max-width: ${sizes.xl})`,
  lgMax: `(max-width: ${sizes.lg})`,
  mdMax: `(max-width: ${sizes.md})`,
  smMax: `(max-width: ${sizes.sm})`,
  xsMax: `(max-width: ${sizes.xs})`,
  xxxlMin: `(min-width: ${sizes.xxxl})`,
  xxlMin: `(min-width: ${sizes.xxl})`,
  xlMin: `(min-width: ${sizes.xl})`,
  lgMin: `(min-width: ${sizes.lg})`,
  mdMin: `(min-width: ${sizes.md})`,
  smMin: `(min-width: ${sizes.sm})`,
  xsMin: `(min-width: ${sizes.xs})`
};

export default devices;
